module.exports = __webpack_public_path__ + "img/phimg2.0f2e492c.png";